import {
  OidcAuthFlow,
  OidcIdentityProviderDto,
  SamlIdentityProviderDto,
} from '../../../../../api-client';

type DisplayedFieldRow = (OidcIdentityProviderDto | SamlIdentityProviderDto) & {
  flow?: OidcAuthFlow;
  usePKCE?: boolean;
};

export type DisplayedField = {
  isObject?: boolean;
  accessor: string;
  label: string;
  accessKey?: string;
  getter?: (row: DisplayedFieldRow) => string | number | boolean | null | undefined;
  isVisible?: (row: DisplayedFieldRow) => boolean;
};

const externalIdpLogoutConfigFields: DisplayedField[] = [
  {
    accessor: 'externalIdpLogoutConfig',
    label: 'IDP Logout enabled',
    isObject: true,
    accessKey: 'enabled',
  },
  {
    accessor: 'externalIdpLogoutConfig',
    label: 'Logout Redirect URL',
    isObject: true,
    accessKey: 'redirectUrl',
  },
];

const pkceConfigFields: DisplayedField[] = [
  {
    accessor: 'flow',
    label: 'Flow',
  },
  {
    accessor: 'usePKCE',
    label: 'Enable PKCE',
    isVisible: (row) => row.flow === OidcAuthFlow.Code,
    getter: (row) => (row.usePKCE ? 'Yes' : 'No'),
  },
  {
    accessor: 'clientSecret',
    label: 'Client Secret',
    isVisible: (row) => row.flow === OidcAuthFlow.Code,
    getter: () => '•••••••',
  },
];

export const OIDC_PROVIDER_DISPLAYED_FIELDS: DisplayedField[] = [
  ...externalIdpLogoutConfigFields,
  {
    accessor: 'connectionId',
    label: 'Provider ID',
  },
  {
    accessor: 'clientId',
    label: 'Client ID',
  },
  {
    accessor: 'issuer',
    label: 'Issuer',
  },
  {
    accessor: 'type',
    label: 'Type',
  },
  {
    accessor: 'userType',
    label: 'User Type',
  },
  {
    accessor: 'externalIdField',
    label: 'External ID Field',
  },
  {
    accessor: 'prompt',
    label: 'Prompt type',
  },
  ...pkceConfigFields,
];

export const SAML_PROVIDER_DISPLAYED_FIELDS: DisplayedField[] = [
  ...externalIdpLogoutConfigFields,
  {
    accessor: 'externalIdField',
    label: 'External ID field',
  },
  {
    accessor: 'connectionId',
    label: 'Connection ID',
  },
  {
    accessor: 'userType',
    label: 'User type',
  },
  {
    accessor: 'prompt',
    label: 'Prompt',
  },
  {
    accessor: 'entityId',
    label: 'Entity ID',
  },
  {
    accessor: 'ssoUrl',
    label: 'SSO URL',
  },
  {
    accessor: 'rpEntityId',
    label: 'Relaying party entity ID',
  },
];
